<template>
  <v-app>
    <v-main
      class="pa-0 px-2 fill-height"
      style="height: auto; "
    >
      <div
        :style="`max-width: 640px;`"
        class="mx-auto fill-width mt-4"
      >
        <v-layout
          :style="`height: 60px;background-color: ${backgroundColor}`"
          align-center
          class="ma-0 pa-0 "
          d-flex
          justify-start
        >
          <div
            :style="`width:5px; height:100%;background-color:${accentColor}`"
            class="mr-4"
          />
          <div
            v-if=" $route.params.novelid !=null"
            style="font-weight: bold;font-size: 18px;"
          >
            小説編集
          </div>
          <div
            v-else
            style="font-weight: bold;font-size: 18px;"
          >
            小説作成
          </div>
        </v-layout>
        <v-card-text class="ma-0 pa-0 ">
          <v-container class="ma-0 pa-0">
            <v-text-field
              v-model="name"
              :background-color="backgroundColor"
              :maxlength="inputLength.title"
              class="mt-4 mb-0 hide-details mb-4"
              dense
              flat
              label="小説のタイトルを入力"
              single-line
              solo
              style="border-radius: 0px"
            />
            <div
              :style="`background-color:${backgroundColor}` "
              class="pa-4"
            >
              <div
                class="mb-2"
                style="font-weight: bold"
              >
                投稿先設定
              </div>
              <div class="mb-4">
                小説を投稿するサイトの種類を設定してください。サイトによってルビの記法や、挿絵の有無が違います。
              </div>
              <v-radio-group
                v-model="siteType"
              >
                <v-radio
                  v-for="(n) in siteTypeList"
                  :key="n.value"
                  :value="n.value"
                >
                  <template v-slot:label>
                    <div>
                      {{ n.label }} <span
                        v-if="n.enableimage==true"
                        class="optionItem"
                      >挿絵○</span> <span
                        class="optionItem"
                      >{{ createRubiFormat(n) }}</span>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="saving"
            :loading="saving"
            class="ma-2"
            color="accent"
            @click="saver = 'saving'"
          >
            保存
          </v-btn>
        </v-card-actions>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import {mapState} from "vuex";
import config from "@/const";
import router from "@/router";


export default {
  name: "NovelEdit",
  ...mapState({
    user: state => state.userModule.user,
    novels: state => state.NovelListModule.NovelList
  }),
  data() {
    return {
      saving: false,
      saver: null,
      siteTypeList: config.SITE_TYPE,
      inputLength: config.INPUT_LENGTH.novel,
      name: "",
      siteType: 0,
      accentColor: null,
      backgroundColor: null,
    }

  },
  watch: {
    $route(to, from) {
      // ルートの変更の検知...
      if (!(typeof to.params.novelid === 'undefined')) {
        const targetNovelId = config.HASH_IDS.decode(to.params.novelid)
        const item = this.$store.state.NovelListModule.NovelList.find(element => element.id == targetNovelId)
        this.name = item.name
        this.siteType = item.targetSite
      } else {
        this.name = ""
        this.siteType = 0
      }
    },
    saver() {
      if (this.saver != null) {
        const l = this.saver
        this[l] = !this[l]
        this.$store.dispatch("NovelListModule/save", {
          id: config.HASH_IDS.decode(this.$route.params.novelid)[0],
          title: this.name,
          siteType: this.siteType
        }).then(value => {
          this[l] = false
          this.saver = null
          router.push({path: "/novels"})
        }).catch(reason => {
          alert("保存中にエラーが発生しました。もう一度保存してください")
          this[l] = false
          this.saver = null
        });
      }

    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    this.backgroundColor = this.$vuetify.theme.dark ? 'black' :
        'white'

  },
  created() {
    if (!(typeof this.$route.params.novelid === 'undefined')) {
      const item = this.$store.state.NovelListModule.NovelList.find(element => element.id == config.HASH_IDS.decode(this.$route.params.novelid)[0])
      this.name = item.name
      this.siteType = item.targetSite
    } else {
      this.name = ""
      this.siteType = 0
    }
  },
  methods: {
    createRubiFormat(siteConfig) {
      if(siteConfig.rubiFormat){
        return `${siteConfig.rubiFormat.prefix}ルビ${siteConfig.rubiFormat.middle}ルビ${siteConfig.rubiFormat.suffix}`
      }else{
        return `ルビ無し`
      }

    }
  }
}
</script>

<style scoped>
.optionItem {
  margin-left: 6px;
  padding: 2px;
  font-size: 11px;
  letter-spacing: 2px;
  background-color: #7D7D7D;
  color: #FFFFFF;
}
</style>
